<section id="oferta-mantenimiento" class="section-wrap bg-light pb-30">
  <div class="container">
    <div class="row oferta-hero">
      <div class="col-md-7">
        <div class="oferta-badge mb-20">
          <span class="oferta-badge-dot"></span>
          <span>{{ badge }}</span>
        </div>
        <h2 class="oferta-title mb-20">
          Mantenimiento de caldera desde <span class="oferta-highlight">9 €/mes</span>
        </h2>
        <p class="oferta-subtitle mb-20">{{ subtitle }}</p>
        <div class="oferta-list">
          <div class="oferta-list-item" *ngFor="let item of bullets">
            <span class="material-symbols-outlined oferta-check">check</span>
            <span>{{ item }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div class="oferta-card">
          <p class="oferta-cta-text">No espere a quedarse sin agua caliente ni calefacción.</p>
          <a class="btn btn-dark oferta-btn" [routerLink]="[route]">Leer más</a>
          <p class="oferta-note">{{ badgeNote }}</p>
          <div class="oferta-seals">
            <span class="oferta-seal">Seguridad</span>
            <span class="oferta-seal">Confort</span>
            <span class="oferta-seal">Ahorro</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
